module.exports = __webpack_public_path__ + "html/coupon_c8a8bf7b58a0eaa02ff4fb0127722e25.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/upgrade/coupon.html
// module id = 52SV
// module chunks = 3